import type { NormalizedBBox } from 'features/knowledgeDocumentViewer/types/ocrViewer'

export const ALIAS_RECT_PADDING = 2

/**
 * Page a highlight belongs to within the rendered image, which spans two pages
 * side by side in a two-page spread.
 */
export function getPageLayout(
  isRightPage: boolean,
  imageNatural: { w: number; h: number },
  firstPageWidth: number | undefined,
  isMultipage: boolean | undefined
): { pageWidth: number; xOffset: number } {
  if (!isMultipage || !firstPageWidth) {
    return { pageWidth: imageNatural.w, xOffset: 0 }
  }
  if (isRightPage) {
    return {
      pageWidth: imageNatural.w - firstPageWidth,
      xOffset: firstPageWidth,
    }
  }
  return { pageWidth: firstPageWidth, xOffset: 0 }
}

/** A highlight's page-fraction box as pixels in the rendered image. */
export function rectGeometry(
  bbox: NormalizedBBox,
  pageWidth: number,
  xOffset: number,
  imageHeight: number
): { x: number; y: number; width: number; height: number } {
  return {
    x: xOffset + bbox.left * pageWidth - ALIAS_RECT_PADDING,
    y: bbox.top * imageHeight - ALIAS_RECT_PADDING,
    width: bbox.width * pageWidth + ALIAS_RECT_PADDING * 2,
    height: bbox.height * imageHeight + ALIAS_RECT_PADDING * 2,
  }
}
